import { Card, CardContent, Tooltip } from "@material-ui/core";
import React, { Component } from "react";
import PedomanSiklus from "./content/PedomanSiklus/PedomanSiklus";
// import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { Notice, YearSelect } from "../../../../_metronic/_partials/controls";
// const bgImage = toAbsoluteUrl("/media/error/bg5.jpg");

class PedomanSiklusPage extends Component {
  render() {
    return (
      <>
        <Notice
          svg="/media/svg/icons/Home/Building.svg"
          style={{ boxShadow: "none" }}
        >
          <div className="d-flex align-items-center justify-content-between w-100">
            <div>
              <strong style={{ fontSize: "18px" }}>PENETAPAN</strong>
              <p className="mb-0">Pedoman Siklus PPEPP Yang Ditetapkan</p>
            </div>
            <div>
              <YearSelect />
            </div>
          </div>
        </Notice>
        <Card style={{ padding: "1%" }}>
          <CardContent>
            <div className="d-flex flex-column pb-10 bgi-size-cover bgi-no-repeat rounded-top">
              <PedomanSiklus idSp={this.props.id_sp} />
            </div>
          </CardContent>
        </Card>
      </>
    );
  }
}
export default PedomanSiklusPage;